import dynamic from 'next/dynamic';
import useAgentData from '~/client/hooks/useAgentData';

const MobileSearch = dynamic(() => import('./MobileSearch'));
const DesktopSearch = dynamic(() => import('./DesktopSearch'));

type Props = {
  searchParam?: string;
};

const Search: FC<Props> = ({ searchParam }) => {
  const { isMobile } = useAgentData();
  if (isMobile) {
    return <MobileSearch searchParam={searchParam} />;
  }
  return <DesktopSearch searchParam={searchParam} />;
};

export default Search;
